import { isDomContentLoaded } from '../../../modules/get_perfomance'
import { getApiUrlString, setUrlMap } from '../../../modules/get_apiUrlString'
import { getCode }  from '../../../modules/get_code'

export default () => {

  const init = () => {
    setUrlMap(window.pist6);
    const worker = new Worker('/assets/js/data/worker/api_thread.js');
    const queryString = '';
    worker.postMessage({
      url: getApiUrlString('seller', queryString),
      cb: (cb).toString()
    })
    worker.addEventListener('message', evt => {
      if (isDomContentLoaded()) {
        buildRace(evt.data);
      } else {
        window.addEventListener('DOMContentLoaded', () => {
          buildRace(evt.data);
        })
      }
    })
  }

  // worker側で実行される処理
  // 取得したデータの再構築
  const cb = (data) => {
    const currentSalesList = data.api.seat_sales_list.map(sales => sales.hold_daily_schedule);
    const groupingScheduleList = [];
    currentSalesList.forEach((schedule, sIdx) => {
      const isGroup = (() => {
        if (sIdx == 0) {
          return false;
        }
        const scheduleDateObj = new Date(schedule.event_date);
        const prevScheduleDateObj = new Date(currentSalesList[sIdx - 1].event_date);
        prevScheduleDateObj.setDate(prevScheduleDateObj.getDate() + 1);
        return (schedule.event_date == currentSalesList[sIdx - 1].event_date)
          || (scheduleDateObj.getTime() == prevScheduleDateObj.getTime());
      })();
      if (groupingScheduleList.length == 0 || !isGroup) {
        groupingScheduleList.push([])
      }
      groupingScheduleList[groupingScheduleList.length - 1].push(schedule);
    })
    const weekMap = [
      '日', '月', '火', '水', '木', '金', '土'
    ]
    const displayScheduleList = groupingScheduleList.map(group => {
      return {
        first_day: group[0].event_date.replace(/-/g, '.'),
        first_week: weekMap[(new Date(group[0].event_date)).getDay()],
        last_day: group[group.length - 1].event_date.replace(/-/g, '.'),
        last_week: weekMap[(new Date(group[group.length - 1].event_date)).getDay()],
        year: group[0].promoter_year % 1000,
        season: group[0].season,
        round_code: group[0].round_code
      }
    })
    // .slice(0, 6)
    postMessage(displayScheduleList);
  }

  // レース一覧DOM生成
  const buildRace = (data) => {
    console.log('seat_sales data:', data);
    const raceUl = document.querySelector('.ti-race-list');
    const programSlot = raceUl.firstElementChild;
    const fragmentElement = document.createDocumentFragment();
    if (data.length) {
      data.forEach(info => {
        const cloneNode = programSlot.cloneNode(true);
        cloneNode.querySelector('.ti-race-list__date').innerHTML = `${info.first_day} [<span class="ti-race-list__week">${info.first_week}</span>] ~ ${info.last_day} [<span class="ti-race-list__week">${info.last_week}</span>]`;
        cloneNode.querySelector('.ti-race-list__name-txt').textContent = `20${info.year}-${info.year + 1} ${getCode('seasonText', info.season).ja || 'ー'} ${getCode('round', info.round_code).name || 'ー'}`;

        fragmentElement.appendChild(cloneNode);
      });
    } else {
      const cloneNode = programSlot.cloneNode();
      const divElement = document.createElement('div');
      divElement.classList.add('ti-race-list__empty');
      divElement.innerHTML = '<p class="ti-race-list__empty-txt">現在チケット発売中の開催はございません。</p>';
      cloneNode.appendChild(divElement);
      fragmentElement.appendChild(cloneNode);
    }

    raceUl.innerHTML = '';
    raceUl.appendChild(fragmentElement);
    raceUl.removeAttribute('aria-hidden');
    raceUl.classList.remove('_skelton');
  }

  init();
}
